import ApiService from "@/core/services/api.service";

//Actions
export const FETCH_MAILS = "fetchSharedMails";

//Mutations
export const SET_LOADING = "setLoadingSharedMail";

const state = {
  isLoadingSharedMail: false
};

const getters = {
  isLoadingSharedMail() {
    return state.isLoadingSharedMail;
  }
};

const actions = {
  [FETCH_MAILS](context, apiParams = "") {
    context.commit(SET_LOADING, true);
    return new Promise((resolve, reject) => {
      ApiService.get("mails" + apiParams)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        })
        .finally(() => {
          context.commit(SET_LOADING, false);
        });
    });
  }
};

const mutations = {
  [SET_LOADING](state, value) {
    state.isLoadingSharedMail = value;
  }
};

export default {
  state,
  actions,
  mutations,
  getters
};
